import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive, faCalendarWeek, faCreditCard, faMoneyBill, faReceipt, faUsers, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import axios from "axios";
import SrvButton from "../../../components/global/SrvButton";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import ErrorAdd from "../../../util/ErrorAdd";

function ModalPay({ show, onHide, idType, model }) {

    const stateBilling = useSelector((state) => state.billing);//Billing

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    const [periodCount, setPeriodCount] = useState(1);
    const [periodAny, setPeriodAny] = useState(false);//Произвольный период
    const [discountPeriod, setDiscountPeriod] = useState([]);//Актуальные скидки по периодам
    const [tariffSum, setTariffSum] = useState(0);//Сумма актульного тарифа

    const [sum, setSum] = useState(0);//Сумма к оплате
    const [discount, setDiscount] = useState(0);//Скидка в %
    const [discountSum, setDiscountSum] = useState(0);//Скидка в рублях

    useEffect(() => {
        axios.get('/api_tracker/billing/discountPeriodWork')
            .then((res) => {
                if (res.data.Status == 1) {
                    setDiscountPeriod(res.data.Data);
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }, []);

    useEffect(() => {
        calcSum();

        if (periodCount > 12) {
            setPeriodCount(12);
        }
        if (periodCount < 1) {
            setPeriodCount(1);
        }

    }, [periodCount, tariffSum]);

    function calcSum() {

        const discountUser_ = stateBilling.company.Discount_User_Percent;
        const discountPeriod_ = discountPeriod.filter(a => periodCount >= a.Count_Start & periodCount <= a.Count_End).length > 0 ? discountPeriod.filter(a => periodCount >= a.Count_Start & periodCount <= a.Count_End)[0].Percent : 0;

        const discount_ = discountUser_ + discountPeriod_;

        setDiscount(discount_);

        const sum_ = stateBilling.company.Tariff_Base * 30 * periodCount * stateBilling.company.Count_User;
        const sum_discount = sum_ / 100 * discount_;

        setDiscountSum(sum_discount);
        setSum(sum_ - sum_discount);
    }

    function tBankPay(idSubscription) {

        setLoading(true);
        setLog(null);

        axios.get('/api_tracker/billing/tBankPay', { params: { Count_Month: periodCount } })
            .then((res) => {
                if (res.data.Status === 1) {
                    window.location.href = res.data.Data;
                }
                else {
                    setLog(res.data.Error);
                    setLoading(false);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-10">
                        Оплата
                    </div>
                    <div className="block_balance">
                        <div className="text-center"><FontAwesomeIcon icon={faUsers} className="opacity-50" /> Пользователи: {stateBilling.company.Count_User}</div>
                        <div style={{ width: '100%' }}>
                            <div className="mt-10 row">
                                <div className="col-lg-6 mt-10">
                                    <button className={'param_button' + (periodCount === 1 ? ' active' : '')} onClick={() => { setPeriodCount(1); setPeriodAny(false) }}>
                                        <i className="mr-5"><FontAwesomeIcon icon={faCalendarWeek} /></i>
                                        1 месяца (без скидки)
                                    </button>
                                </div>
                                <div className="col-lg-6 mt-10">
                                    <button className={'param_button' + (periodCount === 3 ? ' active' : '')} onClick={() => { setPeriodCount(3); setPeriodAny(false) }}>
                                        <i className="mr-5"><FontAwesomeIcon icon={faCalendarWeek} /></i>
                                        3 месяца (скидка 5%)
                                    </button>
                                </div>
                                <div className="col-lg-6 mt-10">
                                    <button className={'param_button' + (periodCount === 6 ? ' active' : '')} onClick={() => { setPeriodCount(6); setPeriodAny(false) }}>
                                        <i className="mr-5"><FontAwesomeIcon icon={faCalendarWeek} /></i>
                                        6 месяцев (скидка 7%)
                                    </button>
                                </div>
                                <div className="col-lg-6 mt-10">
                                    <button className={'param_button' + (periodCount === 12 ? ' active' : '')} onClick={() => { setPeriodCount(12); setPeriodAny(false) }}>
                                        <i className="mr-5"><FontAwesomeIcon icon={faCalendarWeek} /></i>
                                        12 месяцев (скидка 10%)
                                    </button>
                                </div>
                                <div className="col-lg-6 mt-10">
                                    <button className={'param_button' + (periodAny === true ? ' active' : '')} onClick={() => setPeriodAny(true)}>
                                        <i className="mr-5"><FontAwesomeIcon icon={faCalendarWeek} /></i>
                                        Произвольно
                                    </button>
                                </div>

                                {periodAny === true && (
                                    <div className="col-lg-6 mt-10">
                                        <Form.Control type="number" style={{ textAlign: 'center' }} min={1} max={12} value={periodCount} onChange={(e) => setPeriodCount(e.target.value)} />
                                        <small >от 1 до 12 месяцев</small>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="text-center">
                            <div className="mt-15"><b>Сумма {sum}₽ (экономия {discountSum}₽)</b></div>
                            {discount == 0 ? <div className="mt-5"><b>Без скидки</b></div> : <div className="mt-5"><b>Скидка {discount}%</b></div>}
                        </div>

                        <div className="row mt-15">
                            <div className="col-md-6 mb-15">
                                <button className={'payment_source_button param_button'} disabled={loading} onClick={() => tBankPay()}>
                                    <i className="mr-5"><FontAwesomeIcon icon={faCreditCard} /></i>
                                    Карта, СБП
                                </button>
                            </div>
                            <div className="col-md-6 mb-15">
                                <button className={'payment_source_button param_button'} disabled>
                                    <i className="mr-5"><FontAwesomeIcon icon={faReceipt} /></i>
                                    Счет на оплату
                                </button>
                            </div>
                        </div>
                        {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
}
export default ModalPay;
